<template>
<div class="shadow-box" v-if="accountInfo">
  <div class="h3-title flex-row flex-main-axis-between" style="margin-top: 0;">
    <span>基本信息</span>
  </div>
  <div>
    <div class="item">
      <label>账号名称</label>{{ accountInfo.nickName || '--' }}
    </div>
    <div class="item">
      <label>手机号</label>{{ accountInfo.mobilePhone || '--' }}
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      accountInfo: null
    }
  },
  created () {
    let accoutDto = localStorage.getItem('ACCOUNT_DTO')
    this.accountInfo = JSON.parse(accoutDto)
  }
}
</script>
<style scoped>
.item {
  padding-left: 12px;
  line-height: 32px;
  color: #333;
}
.item label {
  display: inline-block;
  min-width: 120px;
  color: #666;
}
</style>
